<p-confirmDialog key="Name" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Group Details-->
<div class="NormalMenu">
	<div class="TitleGrid">
		<label>Group Name:</label>
		<input class="form-control" style="min-width: 300px" [(ngModel)]="GroupName" />
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onUpdateName()">Update Group Name</button>
	</div>
</div>

<!--Unassigned Table-->
<div class="UnassignedMenu TopMargin">
	<caass-unassigned-table [SelectedGroup]="SelectedStudentGroup" [SchoolID]="SchoolID"> </caass-unassigned-table>
</div>

<!--Assigned Table-->
<div class="AssignedMenu TopMargin">
	<caass-assigned-table [SelectedGroup]="SelectedStudentGroup" [SchoolID]="SchoolID"> </caass-assigned-table>
</div>

<!--Action Table-->
<div class="NormalMenu TopMargin">
	<caass-group-action-table [SelectedGroup]="SelectedStudentGroup" [SchoolID]="SchoolID"> </caass-group-action-table>
</div>
